<template>
  <div class="container">
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>
    <b-form v-show="!loading">
      <b-row>
        <!-- Ürün Bilgileri -->
        <b-col class="col-12">
          <b-card header="Ürün Bilgileri" class="mb-3 bg-light">
            <b-row> <!-- Satır grubu oluştur -->
              <b-col class="col-6">
                <b-form-group label="Ürün Adı" label-for="name">
                  <b-form-input id="name" v-model="products.name" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-3">
                <b-form-group label="Birim" label-for="unit">
                  <b-form-input id="unit" v-model="products.unit" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row> <!-- Satır grubu oluştur -->
              <b-col class="col-3">
                <b-form-group label="Alış Fiyatı" label-for="buyingPrice">
                  <b-form-input id="buyingPrice" v-model="products.buyingPrice" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-3">
                <b-form-group label="Satış Fiyatı" label-for="listPrice">
                  <b-form-input id="listPrice" v-model="products.listPrice" disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-3">
                <b-form-group label="KDV Oranı" label-for="vatRate">
                  <b-form-input id="vatRate" v-model="products.vatRate" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6">
          <b-card header="Ürün Seçenekleri" class="mb-3 border-warning">
            <b-form-group label="Seçilebilir Adetler :" label-for="balanceLimit">
              <b-form-tags v-model="products.productOptions" separator=" ,;" add-on-change></b-form-tags>
            </b-form-group>
            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="setOptions" variant="success">
                  <b-icon icon="plus"></b-icon> Güncelle
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col class="col-6">
          <b-card header="Ürün Tipi" class="mb-3 border-warning">
            <b-form-group label="Ürün Tipi :" label-for="balanceLimit">
              <b-form-select
                  v-model="products.type"
                  :options="typeOptions"
                  text-field="name"
                  value-field="id"
              />
            </b-form-group>
            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="setType" variant="success">
                  <b-icon icon="plus"></b-icon> Güncelle
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="col-6">
          <b-card header="İşletme Görünürlüğü" class="mb-3 border-warning">
            <b-form-group label="Ürünün Gösterileceği İşletmeler">
              <multiselect
                  v-model="selectedClients"
                  :options="clients"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :preserve-search="true"
                  track-by="id"
                  label="name"
                  placeholder="İşletme seçin"
              />
            </b-form-group>
            <b-row class="justify-content-end">
              <b-col class="col-auto">
                <b-button @click="setShopVisibility" variant="success">
                  <b-icon icon="plus"></b-icon> Güncelle
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import ProductService from "@/service/ProductService";
  import ProductTypeDefinitionService from "@/service/ProductTypeDefinitionService";
  import Multiselect from "vue-multiselect";
  import ClientService from "@/service/ClientService";
  export default {
    name: "update-product",
    components: {Multiselect},
    data() {
      return {
        products: {
          id: this.$route.params.id,
          name: this.$route.params.name,
          buyingPrice: this.$route.params.buyingPriceText,
          listPrice: this.$route.params.listPriceText,
          vatRate: this.$route.params.vatRate,
          unit: this.$route.params.unit,
          productOptions: this.$route.params.productOptions === undefined ? [] : this.$route.params.productOptions,
          shopVisibilityList: this.$route.params.shopVisibilityList === undefined ? [] : this.$route.params.shopVisibilityList,
          type: this.$route.params.type,
        },
        loading: false,
        typeOptions: [],
        clients: [],
        selectedClients: [],
      };
    },
    methods: {
      async loadProductTypes() {
        this.loading = true;
        try {
          const list = await ProductTypeDefinitionService.list();
          this.typeOptions = [
            { id: null, name: '' },
            ...list
          ];
        } catch (error) {
          console.error("Ürün tipleri çekilirken bir hata oluştu:", error);
        } finally {
          this.loading = false;
        }
      },

      async setOptions() {
        this.loading = true;
        const data = {
          productId: this.$route.params.id,
          productOptions: this.products.productOptions,
        };
        try {
          await ProductService.setOptions(data);
          this.$notification(this, "Ürün seçenekleri başarıyla güncellendi.");
        } catch (error) {
          console.error("Güncelleme sırasında hata oluştu:", error);
        } finally {
          this.loading = false;
        }
      },

      async setType() {
        this.loading = true;
        const data = {
          productId: this.$route.params.id,
          type: this.products.type,
        };
        try {
          await ProductService.setType(data);
          this.$notification(this, "Ürün tipi başarıyla güncellendi.");
        } catch (error) {
          console.error("Güncelleme sırasında hata oluştu:", error);
        } finally {
          this.loading = false;
        }
      },

      async setShopVisibility() {
        this.loading = true;
        const data = {
          productId: this.$route.params.id,
          clientIds: this.selectedClients.map(c => c.id),
        };
        try {
          await ProductService.setShopVisibility(data);
          this.$notification(this, "Ürün işletme görünürlüğü başarıyla güncellendi.");
        } catch (error) {
          console.error("Güncelleme sırasında hata oluştu:", error);
        } finally {
          this.loading = false;
        }
      },

      async loadClients() {
        this.loading = true;
        try {
          const requestBody = {
            columnFilters: {},
            page: 1,
            perPage: 10000,
            sortField: 'name',
            sortDirection: 'asc',
          };
          const response = await ClientService.list(requestBody);
          this.clients = response.data.map(item => ({
            ...item,
            name: item.shortName ? `${item.shortName} (${item.name})` : item.name
          })) || [];
          const shopVisibilityIdList = (this.products.shopVisibilityList || []).map(String);
          this.selectedClients = this.clients.filter(c =>
              shopVisibilityIdList.includes(String(c.id))
          );
        } catch (error) {
          console.error("İşletme listesi alınırken hata oluştu:", error);
          this.$errorNotification &&
          this.$errorNotification(this, "İşletme listesi alınırken hata oluştu.");
        } finally {
          this.loading = false;
        }
      },
    },
    async mounted() {
      await this.loadProductTypes();
      await this.loadClients();
    }
  };
</script>
<style>
  img {
    max-width: 100%;
  }
</style>
